var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.material)?_c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({
    trigger: 'mouseenter',
    theme: 'light-border',
    arrow: true,
  }),expression:"{\n    trigger: 'mouseenter',\n    theme: 'light-border',\n    arrow: true,\n  }"}],staticClass:"material small",attrs:{"content":_vm.getTooltip}},[(_vm.material.image_url)?_c('img',{attrs:{"src":_vm.material.image_url,"alt":"material image"}}):_c('span',{staticClass:"block h-full",style:(_vm.materialColor)})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }